// extracted by mini-css-extract-plugin
export default {"entities-container":"EntityList_entities-container__xYIoW"};